export const selectKeyword = (state) => state.mainReducer.keyword;
